import { Store } from 'pullstate'

const ModalsStore = new Store({ });

export default ModalsStore;